import { FieldSelect } from "./template";

export default FieldSelect;
